// extracted by mini-css-extract-plugin
module.exports = {"container":"svg-module--container--MInsl","gradient":"svg-module--gradient--3cvKN"};